import { alpha, Box, Button, Stack, styled } from '@ltvco/refresh-lib/theme';

export const BannerRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  width: '100%',
  boxSizing: 'border-box',
  borderRadius: theme.spacing(1),
  backgroundColor: alpha(theme.palette.primary.light, 0.6),
  overflow: 'hidden',
  marginTop: theme.spacing(2.5),
  marginBottom: theme.spacing(2.5),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const BannerContent = styled(Stack)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  padding: theme.spacing(2.5, 3),
  gap: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'flex-start',
}));

export const BannerHeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  columnGap: theme.spacing(1),
  flexWrap: 'wrap',
}));

export const BannerCta = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  borderRadius: theme.spacing(4),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '20px',
  textTransform: 'none',
  backgroundColor: theme.palette.common.white,
  borderColor: theme.palette.primary.main,
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.main,
  },
}));

export const BannerIllustration = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
  width: '33%',
  maxWidth: 320,
  '& img, & svg': {
    objectPosition: 'right bottom',
    display: 'block',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '100%',
    justifyContent: 'center',
    '& img, & svg': {
      objectPosition: 'center bottom',
    },
  },
}));
